var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dynamic-map"},[_c('div',{ref:"base",staticClass:"map-container"}),_c('h1',{staticClass:"rank"},[_vm._v("排名第 "+_vm._s(_vm.currentFeature.rank))])])}
var staticRenderFns = []

export { render, staticRenderFns }